module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('MensagemFlutuante', {
    attrs: {
      "mensagemVisivel": _vm.mensagemFlutuante.mensagemVisivel,
      "titulo": _vm.mensagemFlutuante.tituloMensagem,
      "estilo": _vm.mensagemFlutuante.estiloMensagem,
      "texto": _vm.mensagemFlutuante.textoMensagem
    },
    on: {
      "close": _vm.fecharMensagem
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49f42621"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login-seguranca/Login.vue
// module id = 1110
// module chunks = 1